import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import accountReducer from './slices/accounts';
import analyticsReducer from './slices/analytics';
import apiKeysReducer from './slices/apikeys';
import authReducer from './slices/auth';
import currenciesReducer from './slices/currencies';
import customersReducer from './slices/customers';
import dashboardReducer from './slices/dashboard';
import discountsReducer from './slices/discount';
import exportReducer from './slices/export'
import plansReducer from './slices/plans';
import plangroupsReducer from './slices/plangroups';
import paymentsReducer from './slices/payments';
import paymentprocessorsReducer from './slices/paymentprocessors';
import paymentprocessorconfigurationReducer from './slices/paymentprocessorconfiguration';
import subscriptionsReducer from './slices/subscriptions';
import superadminReducer from './slices/superadmin';
import thunkMiddleware from 'redux-thunk';
import transactionsReducer from './slices/transactions';
import usersReducer from './slices/users';
import webhooksReducer from './slices/webhooks';

const loggerMiddleware = createLogger()

const reducers = combineReducers({
    accounts: accountReducer,
    analytics: analyticsReducer,
    apikeys: apiKeysReducer,
    auth: authReducer,
    currencies: currenciesReducer,
    customers: customersReducer,
    dashboard: dashboardReducer,
    discounts: discountsReducer,
    export: exportReducer,
    payments: paymentsReducer,
    paymentprocessors: paymentprocessorsReducer,
    paymentprocessorconfiguration: paymentprocessorconfigurationReducer,
    plangroups: plangroupsReducer,
    plans: plansReducer,
    subscriptions: subscriptionsReducer,
    transactions: transactionsReducer,
    users: usersReducer,
    webhooks: webhooksReducer,
    superadmin: superadminReducer,
})

let middleware = null
if (process.env.NODE_ENV === 'production') {
    middleware = applyMiddleware(
        thunkMiddleware,
    )
} else {
    middleware = composeWithDevTools(applyMiddleware(
        thunkMiddleware,
        loggerMiddleware,
    ))
}

export const store = createStore(reducers, middleware)
